import { render } from "./ReportImages.vue?vue&type=template&id=0519052c&scoped=true"
import script from "./ReportImages.vue?vue&type=script&lang=js"
export * from "./ReportImages.vue?vue&type=script&lang=js"

import "./ReportImages.vue?vue&type=style&index=0&id=0519052c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0519052c"]])

export default __exports__